import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      loading: false,
      mode: "detail",
      staticType: "",
      news: {
        title: "",
        createTime: "",
        content: ""
      },
      categories: [],
      activeTab: "",
      list: []
    };
  },
  computed: {
    detailTitle() {
      if (this.mode === "static") {
        if (this.staticType === "bmlc") {
          return "报名流程";
        }
        if (this.staticType === "pxglgd") {
          return "管理规定";
        }
        return "资讯详情";
      }
      return this.news.title;
    },
    listTitle() {
      const title = this.$route && this.$route.query ? this.$route.query.title : "";
      return title || "信息资讯";
    },
    secondLevelModelType() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const modelType = Number(query.modelType);
      if (modelType === 0 || modelType === 1) {
        return modelType;
      }

      const parentTitle = query.parentTitle || "";
      if (parentTitle === "信息资讯" || parentTitle === "资讯管理") {
        return 0;
      }
      if (parentTitle === "培训通知") {
        return 1;
      }

      if (this.mode === "list") {
        if (this.listTitle === "信息资讯" || this.listTitle === "资讯管理") {
          return 0;
        }
        if (this.listTitle === "培训通知") {
          return 1;
        }
      }
      return 1;
    },
    secondLevelTitle() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      if (query.parentTitle) {
        return query.parentTitle;
      }
      return this.secondLevelModelType === 0 ? "信息资讯" : "培训通知";
    },
    isStaticTwoLevel() {
      return this.mode === "static" && (this.staticType === "bmlc" || this.staticType === "pxglgd");
    },
    staticCrumbTitle() {
      return this.staticType === "bmlc" ? "报名流程" : "管理规定";
    },
    navTitle() {
      if (this.mode === "list") {
        return this.listTitle;
      }
      if (this.mode === "static") {
        return this.detailTitle;
      }
      return "资讯详情";
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.initByRoute();
      }
    }
  },
  created() {
    this.initByRoute();
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    goSecondLevel() {
      this.$router.push({
        path: "/trainNotice",
        query: {
          modelType: String(this.secondLevelModelType)
        }
      });
    },
    async initByRoute() {
      const { query } = this.$route;
      this.loading = true;
      try {
        if (query.newsId) {
          this.mode = "detail";
          await this.loadNewsDetail(query.newsId);
          return;
        }

        if (query.type === "bmlc" || query.type === "pxglgd") {
          this.mode = "static";
          this.staticType = query.type;
          await this.loadStaticContent(query.type);
          return;
        }

        this.mode = "list";
        await this.loadCategories();
        await this.loadListByQueryNcId(query.ncId);
      } finally {
        this.loading = false;
      }
    },
    async loadNewsDetail(newsId) {
      const res = await httpRequest(`/app/news/news/${newsId}`, "get", null);
      if (res && res.code === 200) {
        this.news = res.data || this.news;
      }
    },
    async loadStaticContent(type) {
      const res = await httpRequest(`/app/news/${type}`, "get", null);
      if (res && res.code === 200) {
        this.news = {
          title: this.detailTitle,
          createTime: "",
          content: (res.data && res.data.content) || ""
        };
      }
    },
    async loadCategories() {
      const res = await httpRequest("/app/news/category/categorys", "get", null);
      if (res && res.code === 200 && Array.isArray(res.data)) {
        this.categories = res.data;
      } else {
        this.categories = [];
      }
    },
    async loadListByQueryNcId(ncIdFromQuery) {
      const ncId = this.resolveNcId(ncIdFromQuery);
      if (!ncId) {
        this.activeTab = "";
        this.list = [];
        return;
      }

      this.activeTab = String(ncId);
      await this.loadNewsList(ncId);
    },
    resolveNcId(ncIdFromQuery) {
      if (ncIdFromQuery) {
        const val = Number(ncIdFromQuery);
        if (!Number.isNaN(val) && val > 0) {
          return val;
        }
      }
      if (this.categories.length > 0) {
        return this.categories[0].ncId;
      }
      return null;
    },
    async loadNewsList(ncId) {
      const res = await httpRequest("/app/news/newss", "get", {
        ncId,
        currentPage: 1,
        pageSize: 10000
      });
      if (res && res.code === 200 && res.data && Array.isArray(res.data.list)) {
        this.list = res.data.list;
      } else {
        this.list = [];
      }
    },
    async onCategoryChange(tab) {
      const ncId = Number(tab.name);
      await this.loadNewsList(ncId);
    },
    openDetail(newsId) {
      this.$router.push({
        path: "/news",
        query: {
          newsId,
          modelType: String(this.secondLevelModelType),
          parentTitle: this.secondLevelTitle
        }
      });
    }
  }
};
